import Service from "../../services";

const speciesModule = {
    namespaced: true,
    state: { list: [] },
    mutations: {
        SET_ALL: (state, data) => {
            const otherElement = data.find(d => d.species_name === 'อื่นๆ')
            const unknownElement = data.find(d => d.species_name === 'ไม่ระบุ')
            data = data.filter(d => d.species_name !== 'อื่นๆ' && d.species_name !== 'ไม่ระบุ')

            if (otherElement) {
                data.push(otherElement)
            }
            if (unknownElement) {
                data.unshift(unknownElement)
            }
            state.list = data;
        }
    },
    actions: {
        setAll({ commit }) {
            Service.species.getAllSpecies().then(res => {
                commit("SET_ALL", res);
            });
        },
        getCategory({commit}) {
            return Service.species.getCategory()
        }
    },
    getters: {
        getAll(state) {
            return state.list;
        }
    }
};
export default speciesModule;
